const NOTION_DOMAINS = ["notion.so", "notion.site", "notion.com"];

/** スポンサーのプロジェクトの詳細URLが、案件Notionとしてタームに保存できる URL かを判定する */
export function isNotionProjectUrl(
  projectUrl: string | null,
): projectUrl is string {
  // new URL は前後の空白を取り除いて解釈するので、空白つきの値はここで弾く
  if (!projectUrl || projectUrl !== projectUrl.trim()) return false;

  let url: URL;
  try {
    url = new URL(projectUrl);
  } catch {
    return false;
  }

  return (
    url.protocol === "https:" &&
    NOTION_DOMAINS.some(
      (domain) =>
        url.hostname === domain || url.hostname.endsWith(`.${domain}`),
    )
  );
}
